import axios from "axios";
import {
  SMVM_GET_ANSWER_ASSESSEE_FAIL,
  SMVM_GET_ANSWER_ASSESSEE_REQUEST,
  SMVM_GET_ANSWER_ASSESSEE_RESET,
  SMVM_GET_ANSWER_ASSESSEE_SUCCESS,
  SMVM_GET_LIST_ANSWER_ASSESSEE_FAIL,
  SMVM_GET_LIST_ANSWER_ASSESSEE_REQUEST,
  SMVM_GET_LIST_ANSWER_ASSESSEE_RESET,
  SMVM_GET_LIST_ANSWER_ASSESSEE_SUCCESS,
  SMVM_SET_ANSWER_ASSESSEE_FAIL,
  SMVM_SET_ANSWER_ASSESSEE_REQUEST,
  SMVM_SET_ANSWER_ASSESSEE_RESET,
  SMVM_SET_ANSWER_ASSESSEE_SUCCESS,
} from "../constants/AnswerAssesseeContants";
import { userDataLocalStorage } from "../../../general/functions/base64Function";
import {
  API_GET_ANSWER_ASSESSEE,
  API_GET_LIST_ANSWER_ASSESSEE,
  API_SET_ANSWER_ASSESSEE,
} from "../init/api_url";

export const RSetAnswerAssessee = (data) => async (dispatch) => {
  dispatch({
    type: SMVM_SET_ANSWER_ASSESSEE_RESET,
  });
};

export const SetAnswerAssessee = (val) => async (dispatch) => {
  const { token, session } = userDataLocalStorage();
  let d = session.split("-");
  let sessionId = d[2];
  let projectCode = [d[0], d[1]].join("-");
  try {
    dispatch({
      type: SMVM_SET_ANSWER_ASSESSEE_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data: data } = await axios.post(
      API_SET_ANSWER_ASSESSEE(projectCode, session),
      {
        submission: val,
      },
      config
    );

    dispatch({
      type: SMVM_SET_ANSWER_ASSESSEE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: SMVM_SET_ANSWER_ASSESSEE_FAIL,
      payload: message,
    });
  }
};

export const RGetAnswerAssessee = (data) => async (dispatch) => {
  dispatch({
    type: SMVM_GET_ANSWER_ASSESSEE_RESET,
  });
};

export const GetAnswerAssessee = () => async (dispatch) => {
  const { token, session } = userDataLocalStorage();
  let d = session.split("-");
  let sessionId = d[2];
  try {
    dispatch({
      type: SMVM_GET_ANSWER_ASSESSEE_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data: data } = await axios.get(API_GET_ANSWER_ASSESSEE(), config);

    dispatch({
      type: SMVM_GET_ANSWER_ASSESSEE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: SMVM_GET_ANSWER_ASSESSEE_FAIL,
      payload: message,
    });
  }
};

export const RGetListAnswerAssessee = (data) => async (dispatch) => {
  dispatch({
    type: SMVM_GET_LIST_ANSWER_ASSESSEE_RESET,
  });
};

export const GetListAnswerAssessee = () => async (dispatch) => {
  const { token, session } = userDataLocalStorage();
  let d = session.split("-");
  let sessionId = d[2];
  let projectCode = [d[0], d[1]].join("-");
  try {
    dispatch({
      type: SMVM_GET_LIST_ANSWER_ASSESSEE_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data: data } = await axios.get(
      API_GET_LIST_ANSWER_ASSESSEE(projectCode, session),
      config
    );
    console.log("get list answer assessee", data);
    dispatch({
      type: SMVM_GET_LIST_ANSWER_ASSESSEE_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: SMVM_GET_LIST_ANSWER_ASSESSEE_FAIL,
      payload: message,
    });
  }
};
